export default function PageHeading({ title, icon, description, count, actions }) {
    return <header className="portal-page-heading">
        <div className="portal-page-heading-copy">
            <div className="portal-page-title-row">{icon && <span className="portal-page-icon" aria-hidden="true">{icon}</span>}<h1>{title}</h1>{count !== undefined && <span className="portal-count">{count}</span>}</div>
            {description && <p>{description}</p>}
        </div>
        {actions && <div className="portal-page-actions">{actions}</div>}
    </header>;
}
